import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initSentry } from './lib/sentry'
import { captureArrival } from './lib/acquisition'

// Initialize Sentry BEFORE React mounts so init-time errors get captured.
// No-op in dev / when DSN missing — see src/lib/sentry.ts.
initSentry()

// MGM: keep ?ref= and utm_* before any route redirect can drop them. Only a URL that
// carries them is captured; see src/lib/acquisition.ts.
captureArrival({ search: window.location.search, pathname: window.location.pathname, referrer: document.referrer })

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
